import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { websocketUrl } from '../../queries/constants.ts';
import { useWebsocketToken } from '../../services/Websocket.ts';
import { WebSocketService } from '../../websocket/WebSocketService.ts';
import { Fallback } from './Fleet/Fallback.tsx';
import { Fleet } from './Fleet/Fleet.tsx';
import { MapDashboard } from './Map/MapDashboard.tsx';
import { MapFallback } from './Map/MapFallback.tsx';

export function Dashboard() {
  const params = useParams() as { territorySlug: string };
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const wsService = useMemo(() => new WebSocketService(websocketUrl, queryClient), [queryClient]);

  const { data: websocketToken } = useWebsocketToken();

  useEffect(() => {
    if (websocketToken && params.territorySlug) {
      wsService.connect(websocketToken.WEBSOCKET_TOKEN, params.territorySlug);
    }
  }, [websocketToken?.WEBSOCKET_TOKEN, params.territorySlug]);

  return (
    <div className="container dashboard-container">
      <div className={'row'}>
        <div className="col-3 pe-0 dashboard-col">
          <div className="driver-shift-container">
            <div className="row m-0 p-0 py-3">
              <p className="card-title ms-2">
                <img src="/theme/media/fleet-icon.svg" width="56" height="42" alt="Journey icon" />
                <span className="ms-3">{t('fleet.title')}</span>
              </p>
            </div>
            <ErrorBoundary FallbackComponent={Fallback}>
              <Fleet />
            </ErrorBoundary>
          </div>
        </div>
        <div className="col-9 dashboard-col">
          <ErrorBoundary FallbackComponent={MapFallback}>
            <MapDashboard />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}
